// Vendors
import React from 'react';
// Components
import { LayoutOperationalComponent } from '../operational/layout-operational.component';
// Types
import { LayoutOrchestratorType } from './types/layout-orchestrator.type';

const LayoutOrchestratorComponent = ({
  error,
  errorComponent: LayoutErrorComponent,
  ...restProps
}: LayoutOrchestratorType): React.JSX.Element =>
  error ? <LayoutErrorComponent /> : <LayoutOperationalComponent {...restProps} />;

export { LayoutOrchestratorComponent };
